import React, { useState, useContext, useEffect, useMemo } from 'react';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import MemberController from '../../controllers/member/MemberController';
import { useNavigate } from 'react-router-dom';
import { dbPost } from '../../apis/commonApi';
import { nlPost } from '../../apis/notLoginApi';
import { set } from 'react-hook-form';

const FindId = () => {
  useEffect(() => {
    document.title = '아이디 찾기';
  }, []);
  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const [selectedTab, setSelectedTab] = useState('user'); // 초기값을 'user'로 설정
  const validateService = new ValidateService(modalService);
  const [valueObj, setValueObj] = useState(null);
  const navigate = useNavigate();

  const controller = useMemo(() => {
    return new MemberController(
      { store, updateStore },
      modalService,
      validateService,
      navigate,
      [],
      {
        valueObj,
        setValueObj,
      }
    );
  }, [store, modalService, validateService]);

  const [formData, setFormData] = useState({
    userNm: '',
    userEml: '',
    picNm: '',
    picEml: '',
    userType: 'U', // 초기값을 'U'로 설정
  });

  const [vldParam, setVldParam] = useState({
    userNm: true,
    userEml: true,
    picNm: false,
    picEml: false,
  });

  const [resultData, setResultData] = useState({
    id: '',
    count: null,
  });

  const [showModal, setShowModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
    setFormData(prevFormData => ({
      ...prevFormData,
      userNm: '',
      userEml: '',
      picNm: '',
      picEml: '',
    }));
  };

  const fnValidateEmail = () => {
    let isValid = false;
    if (formData.userType === 'U') {
      isValid = controller.fnValidateEmail(formData.userEml);
    } else if (formData.userType === 'E') {
      isValid = controller.fnValidateEmail(formData.picEml);
    }
    return isValid;
  };

  const navigateTo = url => {
    navigate(url);
  };

  useEffect(() => {
    if (formData.userType === 'U') {
      setVldParam({
        userNm: true,
        userEml: true,
        picNm: false,
        picEml: false,
      });
    } else if (formData.userType === 'E') {
      setVldParam({
        userNm: false,
        userEml: false,
        picNm: true,
        picEml: true,
      });
    }
  }, [formData.userType]);

  const handleTabClick = tab => {
    setSelectedTab(tab);
    setFormData({
      userNm: '',
      userEml: '',
      picNm: '',
      picEml: '',
      userType: tab === 'user' ? 'U' : 'E', // 탭에 따라 userType 설정
    });
  };

  // 입력값 state에 저장
  const handleInputChange = e => {
    const { id, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  const beforePost = async () => {
    const validationRules = {
      userNm: { presence: vldParam.userNm },
      userEml: { presence: vldParam.userEml },
      picNm: { presence: vldParam.picNm },
      picEml: { presence: vldParam.picEml },
    };

    const altKey = {
      userNm: '이름',
      userEml: '이메일',
      picNm: '담당자 이름',
      picEml: '담당자 이메일',
    };

    if (
      await validateService.validateJsCall(formData, validationRules, altKey)
    ) {
      return;
    }
    const isModalShown = fnValidateEmail();
    if (isModalShown) {
      findId();
    }
  };

  const findId = () => {
    const url = '/member/findId.do';
    const param = {
      userNm: formData.userNm,
      userEml: formData.userEml,
      picNm: formData.picNm,
      picEml: formData.picEml,
      userType: formData.userType,
    };
    nlPost(url, param)
      .then(response => {
        // setResultData(response);
        if (response != null) {
          setResultData({
            id: response,
          });
          setShowModal(true);
        } else {
          modalService.errorAlert('해당 정보로 가입된 사용자가 없습니다.');
        }
      })
      .catch(error => {
      });
  };

  useEffect(() => {
    if (resultData.count === 0) {
      modalService.errorAlert('해당 정보로 가입된 사용자가 없습니다.');
    } else if (resultData.id !== '') {
      setShowModal(true);
    }
  }, [resultData]);

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">아이디 찾기</h2>
      </div>
      {/* //페이지 타이틀 영역 */}
      {/* tab menu */}
      <div className="tab-area layer">
        {/* tab list */}
        <div className="tab line full">
          <ul role="tablist">
            <li
              id="tab_login_01"
              role="tab"
              aria-selected={selectedTab === 'user'}
              aria-controls="panel_login_01"
              className={selectedTab === 'user' ? 'active' : ''}
            >
              <button
                type="button"
                className="btn-tab"
                onClick={() => handleTabClick('user')}
              >
                사용자 아이디 찾기{' '}
                {selectedTab === 'user' && (
                  <i className="sr-only created">선택됨</i>
                )}
              </button>
            </li>
            <li
              id="tab_login_02"
              role="tab"
              aria-selected={selectedTab === 'company'}
              aria-controls="panel_login_02"
              className={selectedTab === 'company' ? 'active' : ''}
            >
              <button
                type="button"
                className="btn-tab"
                onClick={() => handleTabClick('company')}
              >
                기업 사용자 아이디 찾기
                {selectedTab === 'company' && (
                  <i className="sr-only created">선택됨</i>
                )}
              </button>
            </li>
          </ul>
        </div>
        {/* //tab list */}

        {/* tab contents */}
        <div className="tab-conts-wrap">
          <section
            id="panel_login_01"
            role="tabpanel"
            aria-labelledby="tab_login_01"
            className={`tab-conts ${selectedTab === 'user' ? 'active' : ''}`}
          >
            <h3 className="sr-only">사용자 아이디 찾기</h3>
            <p className="text-gray-70">
              성명과 이메일 주소를 통해 아이디를 찾으실 수 있습니다.
            </p>
            {/* 로그인 폼 */}
            <div className="login-form-area type-tab">
              <div className="login-wrap">
                <div className="in">
                  <fieldset>
                    <legend>사용자 아이디 찾기</legend>
                    <div className="fieldset">
                      <div className="form-group">
                        <div className="form-tit">
                          <label htmlFor="userNm">성명</label>
                        </div>
                        <div className="form-conts">
                          <input
                            type="text"
                            id="userNm"
                            value={formData.userNm}
                            className="form-control"
                            placeholder=""
                            onChange={handleInputChange}
                            aria-labelledby="userNm"
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="form-tit">
                          <label htmlFor="userEml">이메일 주소</label>
                        </div>
                        <div className="form-conts">
                          <input
                            type="text"
                            id="userEml"
                            value={formData.userEml}
                            className="form-control"
                            placeholder=""
                            onChange={handleInputChange}
                            aria-labelledby="userEml"
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <button
                          type="button"
                          className="btn primary open-modal"
                          data-target="search_id"
                          onClick={beforePost}
                        >
                          아이디 찾기
                        </button>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
            {/* //로그인 폼 */}
          </section>
          <section
            id="panel_login_02"
            role="tabpanel"
            aria-labelledby="tab_login_02"
            className={`tab-conts ${selectedTab === 'company' ? 'active' : ''}`}
          >
            <h3 className="sr-only">사용자 아이디 찾기</h3>
            <p className="text-gray-70">
              성명과 이메일 주소를 통해 아이디를 찾으실 수 있습니다.
            </p>
            {/* 로그인 폼 */}
            <div className="login-form-area type-tab">
              <div className="login-wrap">
                <div className="in">
                  <fieldset>
                    <legend>사용자 아이디 찾기</legend>
                    <div className="fieldset">
                      <div className="form-group">
                        <div className="form-tit">
                          <label htmlFor="picNm">담당자 성명</label>
                        </div>
                        <div className="form-conts">
                          <input
                            type="text"
                            id="picNm"
                            value={formData.picNm}
                            className="form-control"
                            placeholder=""
                            onChange={handleInputChange}
                            aria-labelledby="picNm"
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="form-tit">
                          <label htmlFor="picEml">담당자 이메일 주소</label>
                        </div>
                        <div className="form-conts">
                          <input
                            type="text"
                            id="picEml"
                            value={formData.picEml}
                            className="form-control"
                            placeholder=""
                            onChange={handleInputChange}
                            maxLength={50}
                            aria-labelledby="picEml"
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <button
                          type="button"
                          className="btn primary open-modal"
                          data-target="search_id"
                          onClick={beforePost}
                        >
                          아이디 찾기
                        </button>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
            {/* //로그인 폼 */}
          </section>
        </div>
        {/* //tab contents */}
      </div>
      {showModal && (
        <section
          id="search_id"
          className="modal fade in shown"
          role="dialog"
          aria-labelledby="tit_search_id"
          aria-hidden={!showModal}
        >
          <div className="modal-dialog sm">
            <div className="modal-content">
              {/* modal title */}
              <div className="modal-header">
                <h2 id="tit_search_id" className="modal-title">
                  아이디 찾기 결과
                </h2>
              </div>
              {/* //modal title */}
              {/* modal contents */}
              <div className="modal-conts">
                <div className="txt-box center">
                  <p className="text-gray-90">
                    사용자님께서 요청하신 아이디를 알려드립니다.
                  </p>
                  <p className="text-gray-90 gap-sm">
                    아이디 : <strong>{resultData.id}</strong>
                  </p>
                </div>
              </div>
              {/* //modal contents */}
              {/* modal btn */}
              <div className="modal-btn btn-wrap both">
                <button
                  type="button"
                  className="btn md tertiary"
                  onClick={() => {
                    navigateTo('/member/findPassword');
                  }}
                >
                  비밀번호 찾기
                </button>
                <button
                  type="button"
                  className="btn md primary"
                  onClick={() => {
                    navigateTo('/member/login');
                  }}
                >
                  로그인 하기
                </button>
              </div>
              {/* //modal btn */}
              {/* close button */}
              <button
                type="button"
                className="btn-close close-modal"
                onClick={() => {
                  closeModal();
                }}
              >
                <span className="sr-only">닫기</span>
              </button>
              {/* //close button */}
            </div>
          </div>
          <div className="modal-back in"></div>
          {/* </div> */}
        </section>
      )}
    </>
  );
};

export default FindId;
